import http from "../jslibs/axios/http";

// 轮播图列表
export const getScrollList = (data) => http.get("/v1/cms/Banner", data);

// 获取轮播图详情
export const getScrollDetail = (uuid) => http.get(`/v1/cms/Banner/${uuid}`);

// 编辑轮播图
export const editScroll = (uuid, data) => http.put(`/v1/cms/Banner/${uuid}`, data);

// 新增轮播图
export const saveScroll = (data) => http.post("/v1/cms/Banner", data);

// 删除轮播图
export const deleteScroll = (uuid) => http.delete(`/v1/cms/Banner/${uuid}`);

// 上架/下架轮播图
export const bannerShowScroll = (uuid) => http.get(`/v1/cms/BannerShow/${uuid}`);

// 友情链接列表
export const linksList = (data) => http.get("/v1/cms/Links", data);

// 新增友情链接
export const addLinks = (data) => http.post("/v1/cms/Links", data);

// 删除友情链接
export const deleteLinks = (id) => http.delete(`/v1/cms/Links/${id}`);

// 获取友情链接详情
export const getLinksDetail = (id) => http.get(`/v1/cms/Links/${id}`);

// 编辑友情链接
export const editLinks = (id, data) => http.put(`/v1/cms/Links/${id}`, data);

// // 行业方案列表
// export const industrySchemeList = data => http.get('/v1/cms/IndustryScheme', data)

// // 新增行业方案
// export const addIndustryScheme = data => http.post('/v1/cms/IndustryScheme', data)

// // 删除行业方案
// export const deleteIndustryScheme = id => http.delete(`/v1/cms/IndustryScheme/${id}`)

// // 获取行业方案详情
// export const getIndustrySchemeDetail = id => http.get(`/v1/cms/IndustryScheme/${id}`)

// // 编辑行业方案
// export const editIndustryScheme = (id, data) => http.put(`/v1/cms/IndustryScheme/${id}`, data)

// 行业洞察列表
export const industryInsightList = (data) => http.get("/v1/cms/IndustryInsight", data);
// 新增行业洞察
export const addIndustryInsight = (data) => http.post("/v1/cms/IndustryInsight", data);
// 删除行业洞察
export const deleteIndustryInsight = (uuid) => http.delete(`/v1/cms/IndustryInsight/${uuid}`);
// 上架/下架行业洞察
export const IndustryInsightOption = (uuid) => http.get(`/v1/cms/IndustryInsightOption/${uuid}`);
// 编辑行业洞察
export const editIndustryInsight = (uuid, data) => http.put(`/v1/cms/IndustryInsight/${uuid}`, data);
// 详情行业洞察
export const detailsIndustryInsight = (uuid) => http.get(`/v1/cms/IndustryInsight/${uuid}`);
// 设为推荐/取消推荐
export const SetIndustryInsightRec = (data) => http.post(`/v1/cms/IndustryInsightRec`, data);
